import { useNavigate } from 'react-router-dom';

const BtnToProduct = ({decoders}) => {
    const nav = useNavigate();
    const toProduct = () => {
      if (decoders === 'error') nav('/login');
      else if(decoders === null) window.location.href = 'https://www.globlink.ge/?product=67'
      else nav('/balance')
    }
    return <button onClick={toProduct} className='tariff-btn'>Buy service</button>
}

export default BtnToProduct;